import React from 'react';
import { MapPin } from 'lucide-react';
export function LivoniaDistance() {
  return <section className="bg-charcoal text-white py-6" data-id="element-2384">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-center gap-3" data-id="element-2385">
        <MapPin className="w-6 h-6 text-storm-red" data-id="element-2386" />
        <span className="text-lg font-bold uppercase tracking-wide" data-id="element-2387">
          Conveniently located near Livonia
        </span>
      </div>
    </section>;
}